import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SharedFeedback } from "../../modules/user/shared_feedback/typeSharedFeedbacks";
import { FeedbackListSliceProps } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const getSharedFeedbackListByMember = createAsyncThunk(
  "admin/feedback/shared",
  async (requestParams: FeedbackListSliceProps, storeActions) => {
    const url = `api/v1/admin/member/detail/feedback/shared?memberId=${requestParams.memberId}&offSet=${requestParams.offSet}&count=${requestParams.count}`;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const sharedFeedbackListByMemberSlice = createSlice({
  name: "sharedFeedbackListByMember",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: null as Array<SharedFeedback> | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSharedFeedbackListByMember.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(getSharedFeedbackListByMember.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(getSharedFeedbackListByMember.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = sharedFeedbackListByMemberSlice.actions;

export default sharedFeedbackListByMemberSlice;
